import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_ACCCESS_UNIX_PATHS_TABLE } from '../../../../../../../webcomponents.constants';
import { GzPolicyUiSettingsTableWebComponent } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/dataTable';
import { getTableColumns } from './grid-config';
import { html, TemplateResult } from 'lit';
import { GRID_ITEM_FORM_ID } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/base/component/GzPolicyUiSettingsBaseGrid';
import { ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';
import { validateDuplicates } from './utils/validators';
import { FontSizes, FontWeights } from '../../../../../../../types/common/types';
import { translateFn } from '../../../../../../../utils/translator.helper';

@customElement(WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_ACCCESS_UNIX_PATHS_TABLE)
export class GzAntimalwareOnAccessUnixPathsTableWebComponent extends GzPolicyUiSettingsTableWebComponent<
  { path: string },
  { path: string }
> {
  protected hasReorderRowAction = false;
  protected columns = getTableColumns();

  protected renderGridItemForm(): TemplateResult {
    return html`
      <gz-policy-panel-antimalware-on-access-unix-paths-item
        id="${GRID_ITEM_FORM_ID}"
      ></gz-policy-panel-antimalware-on-access-unix-paths-item>
      <gz-text
        style="padding-top: 8px; padding-bottom: 8px;"
        fontSize="${FontSizes.PARAGRAPH_12}"
        fontWeight="${FontWeights.NORMAL}"
        >${translateFn('Enter Linux directory paths, one at a time. For example: /home')}</gz-text
      >
    `;
  }

  protected validateGridItemBeforeAdd(gridItemFormValue: { path: string }): ValidationResult {
    return validateDuplicates(gridItemFormValue, this.gridComponent.getFormValue());
  }

  protected validateGridItemBeforeEdit(oldItem: { path: string }, newItem: { path: string }): ValidationResult {
    if (oldItem.path === newItem.path) {
      return { valid: true };
    }

    return validateDuplicates(newItem, this.gridComponent.getFormValue());
  }
}
